<template>
  <div class="gerenciamento-automacao">
    <g-card
      largura="calc(100vw - 20px)"
      altura="fit-content"
      class="card-gerenciamento-automacao"  
    >
      <template #cabecalho>
        <div class="card-gerenciamento-automacao-titulo">Automação</div>
      </template>            
      <g-form>
        <div class="automacao">
          <p class="card-subtitulo">Gerenciamento de Automação</p>
          <div class="automacao-content">
            <div class="row">
              <div class="input-container col-4" id="inputTipoFluxo">
                <div class="g-input-label">
                  Tipo de Fluxo <strong class="asterisco-obrigatorio">*</strong>
                </div>
                <PDropDown
                  class="input"
                  placeholder="Selecione o tipo de fluxo"
                  v-model="tipoFluxoSelecionado"
                  :options="tiposFluxo"
                  optionLabel="descricao"
                  optionValue="valor"
                  :loading="loadingTiposFluxo"
                  @change="onTipoFluxoChange"
                />
              </div>
              <div class="input-container col-4" id="input1">
                <div class="g-input-label">Número do Pedido da Suprema</div>
                <div class="input-with-loading">
                  <PInputNumber
                    class="input"
                    placeholder="Digite o número do pedido"
                    v-model="numeroPedido"
                  />
                  <i v-if="loading" class="pi pi-spin pi-spinner loading-icon"></i>
                </div>
              </div>
              <div class="input-container col-4" id="input2" v-if="checkboxNovo === false">
                <div class="g-input-label">Nome do Produto</div>
                <PDropDown
                  class="input"
                  placeholder="Selecione o produto"
                  :filter="true"
                  v-model="produtoSelecionado"
                  :options="produtos"
                  optionLabel="labelProduto"
                  optionValue="produtoId"
                  @filter="buscarProdutos($event.value)"
                />
              </div>
              <div class="input-container col-4" id="input1" v-if="checkboxNovo === true">
                <div class="g-input-label">Nome do Produto</div>
                <PInputText
                  class="input"
                  placeholder="Digite o nome do produto"
                  v-model="nomeProduto"
                  :maxlength="30"
                />
              </div>
              <div class="input-container col-4" id="input3">
                <div class="g-input-label">Data de Carregamento</div>
                <g-date-input

                  :key="key"
                  class="input"
                  v-model="dataCarregamento"
                  largurainput = "1000px"

                />
              </div>

              <div class="input-container col-4" id="input3" v-if="tipoFluxoSelecionado === 0">
                <div class="g-input-label">OS</div>
                <PInputText
                  disabled
                  class="input"
                  v-model="OS"
                />
              </div>
            </div>

            <!-- Campos específicos para CARTAO_IMPRESSO (tipoFluxo = 1) -->
            <div class="row" v-if="tipoFluxoSelecionado === 1">
              <div class="input-container col-4">
                <div class="g-input-label">
                  Produto Suprema <strong class="asterisco-obrigatorio">*</strong>
                </div>
                <PDropDown
                  class="input"
                  placeholder="Preenchido automaticamente"
                  v-model="produtoSupremaId"
                  :options="produtosSuprema"
                  optionLabel="nomeProduto"
                  optionValue="produtoId"
                  :disabled="true"
                >
                  <template #value="slotProps">
                    <div v-if="slotProps.value">
                      <strong>{{ codigoProdutoSuprema }}</strong> - {{ produtoSupremaNome }}
                    </div>
                    <span v-else>{{ slotProps.placeholder }}</span>
                  </template>
                </PDropDown>
              </div>

              <div class="input-container col-4">
                <div class="g-input-label">
                  Qtd Total Pedido de Chapa <strong class="asterisco-obrigatorio">*</strong>
                </div>
                <PInputNumber
                  class="input"
                  v-model="quantidadeTotalPedidoImpressao"
                  mode="decimal"
                  :min="1"
                  placeholder="Quantidade total"
                />
              </div>

              <div class="input-container col-4">
                <div class="g-input-label">
                  Qtd Folhas Base Custo<strong class="asterisco-obrigatorio">*</strong>
                </div>
                <PInputNumber
                  class="input"
                  v-model="quantidadeFolhasBaseCusto"
                  mode="decimal"
                  :min="1"
                  placeholder="Qtd para cálculo de custo"
                />
              </div>
            </div>

            <!-- Campos específicos para FORMATO (tipoFluxo = 0) quando for Produto Novo -->
            <!-- Para VENDA IMPRESSÃO (tipoFluxo = 1), essas infos são puxadas do produto base Suprema -->
            <div class="row" v-if="checkboxNovo === true && tipoFluxoSelecionado === 0">
              <div class="input-container col-4" id="input2" >
                <div class="g-input-label">Papel de Onda <strong class="asterisco-obrigatorio">*</strong></div>
                <PDropDown
                  class="input"
                  :options="PapelOndaArray"
                  optionLabel="text"
                  optionValue="value"
                  placeholder="Insira o papel"
                  v-model="papelOnda"
                />
              </div>

              <div class="input-container col-6" id="input5">
                <div class="g-input-label"> Gramatura da Onda <strong class="asterisco-obrigatorio">*</strong></div>
                <PInputNumber
                    class="input"
                    :max="100000000"
                    locale="pt-BR"
                    :minFractionDigits="0"
                    :value="NumeroGramaturaPapelOnda"
                    v-model="NumeroGramaturaPapelOnda"
                />
              </div>

              <div class="input-container col-4" id="input2" >
                <div class="g-input-label">Capa Interna <strong class="asterisco-obrigatorio">*</strong></div>
                <PDropDown
                  class="input"
                  :options="CapaInternaArray"
                  optionLabel="text"
                  optionValue="value"
                  placeholder="Insira"
                  v-model="DescricaoCapaInterna"
                />
              </div>

              <div class="input-container col-6" id="input5">
                <div class="g-input-label"> Gramatura Capa Interna <strong class="asterisco-obrigatorio">*</strong></div>
                    <PInputNumber
                    locale="pt-BR"
                    class="input"
                    :minFractionDigits="0"
                    :value="NumeroGramaturaCapaInterna"
                    v-model="NumeroGramaturaCapaInterna"
                    ></PInputNumber>
              </div>
            </div>

            <!-- Placeholder para TERCEIRIZACAO (tipoFluxo = 2) -->
            <div class="row" v-if="checkboxNovo === true && tipoFluxoSelecionado === 2">
              <div class="input-container col-12">
                <div class="g-input-label" style="color: #666; font-style: italic;">
                  Campos específicos para Terceirização serão implementados nas próximas tarefas (Tarefa 3.3)
                </div>
              </div>
            </div>

            <div class="row">
              <div class="input-container col-3" id="input2">
                <div class="chackbox-novo-produto">
                  <PCheckBox
                  name="extr"
                  value="exterior-value"
                  :binary="true"
                  @click="checkboxNovoAlterar"
                  v-model="checkboxNovo"
                  ></PCheckBox>
                  <div class="g-input-label margin-texto">Novo Produto</div>
                </div>
              </div>
            </div>

            <!-- Quantidade para CARTAO_IMPRESSO -->
            <div class="row" v-if="tipoFluxoSelecionado === 1">
              <div class="input-container col-4" id="input4">
                <div class="g-input-label">Quantidade Total do Pedido</div>
                <PInputNumber
                  class="input"
                  v-model="quantidade"
                  mode="decimal"
                  type="int"
                  :disabled="true"
                />
              </div>
            </div>

            <!-- Quantidade e campos de medidas para FORMATO - tudo na mesma linha -->
            <div class="row" v-if="tipoFluxoSelecionado === 0">
              <div class="input-container" style="flex: 0 0 18%;" id="input4">
                <div class="g-input-label">Quantidade</div>
                <PInputNumber
                  class="input"
                  v-model="quantidade"
                  mode="decimal"
                  type="int"
                />
              </div>
              <div class="input-container" style="flex: 0 0 20%;" id="input5">
                <div class="g-input-label">Sentido da Onda</div>
                  <PInputNumber
                    v-model="sentidoOnda"
                    :disabled="checkboxNovo === false"
                    class="input"
                    :max="999"
                    :minFractionDigits="2"
                    :maxFractionDigits="2"
                    :step="0.01"
                    mode="decimal"
                    locale="pt-BR"
                  />
              </div>
              <div class="input-container" style="flex: 0 0 26%;" id="input5">
                <div class="g-input-label">Medida Faca Aberta Comprimento</div>
                <PInputNumber
                  v-model="medidaFacaAbertaComprimento"
                  :disabled="checkboxNovo === false"
                  class="input"
                  :max="999"
                  :minFractionDigits="2"
                  :maxFractionDigits="2"
                  :step="0.01"
                  mode="decimal"
                  locale="pt-BR"
                />
              </div>
              <div class="input-container" style="display: flex; justify-content: center; align-items: center; margin-top: 20px; flex: 0 0 3%;" id="input5">
                <strong style="font-size: 1.2rem;">X</strong>
              </div>
              <div class="input-container" style="flex: 0 0 26%;" id="input5">
                <div class="g-input-label">Medida Faca Aberta Largura</div>
                <PInputNumber
                  v-model="medidaFacaAbertaLargura"
                  :disabled="checkboxNovo === false"
                  class="input"
                  :max="999"
                  :minFractionDigits="2"
                  :maxFractionDigits="2"
                  :step="0.01"
                  mode="decimal"
                  locale="pt-BR"
                />
              </div>
            </div>

            <!-- Quantidade para TERCEIRIZACAO -->
            <div class="row" v-if="tipoFluxoSelecionado === 2">
              <div class="input-container col-4" id="input4">
                <div class="g-input-label">Quantidade</div>
                <PInputNumber
                  class="input"
                  v-model="quantidade"
                  mode="decimal"
                  type="int"
                />
              </div>
            </div>

            <!-- Campo Descrição para CARTAO_IMPRESSO - antes do grid de parcelas -->
            <div class="row" v-if="tipoFluxoSelecionado === 1">
              <div class="input-container col-12" id="input6">
                <div class="g-input-label">Descrição</div>
                <PTextArea
                  class="input"
                  v-model="descricao"
                  rows="3"
                  autoResize
                />
              </div>
            </div>

            <!-- Grid de Parcelas - apenas para CARTAO_IMPRESSO -->
            <div v-if="tipoFluxoSelecionado === 1">
              <hr style="margin: 20px 0;" />
              <GridParcelas
                :parcelas="parcelas"
                :quantidade-total-pedido="quantidadeTotalPedidoImpressao"
                @adicionar-parcela="abrirDialogParcela()"
                @editar-parcela="salvarParcelaInline($event)"
                @excluir-parcela="excluirParcela($event)"
              />
            </div>

            <!-- Campo Descrição para FORMATO e TERCEIRIZACAO - no final -->
            <div class="row" v-if="tipoFluxoSelecionado !== 1">
              <div class="input-container col-12" id="input6">
                <div class="g-input-label">Descrição</div>
                <PTextArea
                  class="input"
                  v-model="descricao"
                  rows="3"
                  autoResize
                />
              </div>
            </div>
          </div>
        </div>
      </g-form>
      <div v-if="checkboxNovo === false">
        <hr/>
      </div>
      <g-form  v-if="checkboxNovo === false">
        <div class="automacao">
          <p class="card-subtitulo">Componente Selecionado</p>
          <g-data-table
            class="data-table-conteudo"
            Titulo="Componente"
            v-on:acaoAdicionar="abrirPopupComponente"
            :colunas="colunas"
            :valores="componentesSelecionadosGrid"
            :filtros="filtro"
            :editavel="false"
            :rowEditor="false"
            :Adicionavel="produtoSelecionado"
            :escondeColunaBotao="false"
            @remover="removerComponente"
          >
            <template #acoes="slotProps">
              <g-button
                tipo="vermelho"
                altura="35px"
                largura="100%"
                negritoTexto
                @click="removerComponente(slotProps.data)"
              >
                REMOVER
              </g-button>
            </template>
          </g-data-table>
        </div>
      </g-form>
      <hr/>
      <g-form>
        <div class="button-container">
          <g-button
            class="button"                     
            negritoTexto                    
            tamanhoTexto="12px"
            altura="35px"
            @click="validations"
            :sombreado="false"
            :disabled="isSalvando"
          >
            GRAVAR
          </g-button>
        </div>
      </g-form>
    </g-card>
  </div>

  <PDialog 
    :showHeader="false" 
    :closable="false" 
    v-model:visible="popupComponente" 
    :modal="true" 
    :style="{ margin: '0 5%', maxWidth: '470px' }"
  >
    <div class="titulo-popup-finalizado popups-consultar-orcamentos">
      Selecione um componente
    </div>
    
    <div class="produto-select-popup">
      <PDropDown
        :options="componentes"
        optionLabel="componenteProporcaoLabel"
        optionValue="id"
        placeholder="Selecione o componente"
        v-model="componenteSelecionado"
        @change="buscarComponenteSelecionado"
      />
    </div>

    <div class="botoes-popup">
      <div>
        <g-button
          tipo="cinza"
          negritoTexto 
          largura="200px" 
          altura="35px" 
          @click="popupComponente = false"
        >
          CANCELAR
        </g-button>
      </div>
      <div>
        <g-button
          negritoTexto
          largura="200px" 
          altura="35px" 
          @click="adicionarComponente"
        >
          ADICIONAR
        </g-button>
      </div>
    </div>
  </PDialog>
    <PDialog 
    :showHeader="false" 
    :closable="false" 
    v-model:visible="popupSucesso" 
    :modal="true" 
    :style="{ margin: '0 5%', maxWidth: '470px' }"
  >
    <div class="titulo-popup-finalizado popups-consultar-orcamentos">
      Código do orçamento
    </div>

    <div class="titulo-popup-codigo popups-consultar-orcamentos">
      {{codigoExterno}}
    </div>

    <div class="botoes-popup">
      <div>
        <g-button
          tipo="cinza"
          negritoTexto 
          largura="200px" 
          altura="35px" 
          @click="popupSucesso = false"
        >
          FECHAR
        </g-button>
      </div>
    </div>
  </PDialog>

  <!-- Dialog de Parcelas -->
  <DialogParcela
    v-model="dialogParcelaVisible"
    :parcela="parcelaEmEdicao"
    :quantidade-total-pedido="quantidadeTotalPedidoImpressao"
    :parcelas-existentes="parcelas"
    @salvar="salvarParcela"
  />

  <Toast />
</template>

<script>
import GerenciamentoAutomacao from './GerenciamentoAutomacao.js'
export default GerenciamentoAutomacao
</script>

<style scoped>

.chackbox-novo-produto{
  display: flex;
  align-items: center;
}
.button{
  margin: 10px 0 10px 0;
  width: 100%;
}
.margin-texto{
  margin-left: 0.5rem;

}
.input{
  width: 100%;
  margin: 10px 0 10px 0;
}
.automacao-content{
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.row {
  display: flex;
  gap: 20px;
  width: 100%;
}
.input-container{
  text-align: left;
}
.col-4 {
  width: calc(25% - 14px);
}
.col-6 {
  width: calc(50% - 10px);
}
.col-12 {
  width: 100%;
}
.card-subtitulo{
  text-align: left;
  color: #4f2c19;
  font-weight: bold;
  font-size: 1.2rem;
}
.gerenciamento-automacao{
  width: 100%;
  margin: 0 auto;
  overflow-x: hidden;
}
.info-box {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 12px 16px;
  background-color: #e3f2fd;
  border: 1px solid #90caf9;
  border-radius: 6px;
  margin-top: 10px;
}
.info-box i {
  color: #1976d2;
  font-size: 1.2rem;
  margin-top: 2px;
}
.info-box span {
  color: #1976d2;
  font-size: 0.9rem;
  line-height: 1.5;
}
.p-text-secondary {
  display: block;
  color: #6c757d;
  font-size: 0.85rem;
  margin-top: 4px;
  font-style: italic;
}
.card-gerenciamento-automacao{
  display: flex;
  flex-direction: column;
  width: 100%;
}
.card-gerenciamento-automacao-titulo{
  text-align: left;
  color: #4f2c19;
  font-weight: bold;
  font-size: 1.2rem;
}
.automacao {
  margin: 0px 10px 0px 10px;
  width: calc(100% - 20px);
}

.g-date-input {
  justify-content: start;
  width: 100%;
}

:deep(.g-date-input .p-calendar) {
  width: auto;
}

:deep(.g-date-input .p-inputtext) {
  width: 100%;
}

.data-table-conteudo {
  margin: 20px 0;
  width: 100%;
}

.titulo-popup-finalizado {
  font-size: 1.2rem;
  font-weight: bold;
  color: #4f2c19;
  text-align: center;
  margin-bottom: 20px;
}

.titulo-popup-codigo {
  font-size: 1.1rem;
  font-weight: bold;
  color: #464646;
  text-align: center;
  margin-bottom: 10px;
}

.produto-select-popup {
  margin: 20px 0;
  width: 100%;
}

.botoes-popup {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  width: 100%;
}

:deep(.p-dialog .p-dialog-content) {
  padding: 1.5rem;
}

@media (max-width: 1024px) {
  .row {
    flex-direction: column;
  }
  .col-4, .col-6, .col-12 {
    width: 100%;
  }
}

@media (min-width:1025px) {
  .button{
    width: 40%;
  }

  .button-container{
    display: flex;
    width: 40%;
    flex-direction: row;
    justify-content: center;
    margin: 0 auto;
  }
}

/* Estilos para indicador de loading no campo de número do pedido */
.input-with-loading {
  position: relative;
}

.loading-icon {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  color: #2196F3;
  font-size: 1.2rem;
}
</style>
